export default "__VITE_ASSET__cf14bb7f__"